const AboutMe = () => {
  return (
    <section>
      <h2 className="title-font pink-text h2-tag">About Me</h2>
      <p className="white-text p-tag">
        Namaste! Main Vaishnavi (Vaishnavi) hoon, aur main ek passionate volleyball player hoon jo apne khel ke saath-saath zindagi ke har pehlu ko celebrate karti hun. Volleyball mere liye ek passion hai, ek khel hai jisme main apne aapko khoya hua mehsoos karti hoon aur har baar ek nayi udaan bharti hoon.

Mujhe game khelna bahut pasand hai aur volleyball mere liye sirf ek khel nahi, balki ek jeevan darshan hai. Is khel mein mujhe khud ko sabse connected aur jeevit mahsoos hota hai. Main har baar court par step karke, apne saathiyon ke saath teamwork aur coordination ka anand leti hoon.

Volleyball mere liye number 1 hai, aur ismein mera passion aur commitment dikhta hai har ek serve, spike aur block mein. Har game ek nayi opportunity hai apne skills ko improve karti hun

Jab main nahi volleyball khel rahi hoon, tab mujhe bike pe baithne ka bhi behad shauk hai. Bike se nikal kar, zindagi ke raston ko explore karna aur nayi adventures ko discover karna mujhe bahut khushi deta hai.

Mathematics mere liye ek aur passion hai. Mujhe numbers aur patterns mein dilchaspi hai aur main hamesha koshish karti hoon ki har mushkil ko ek naya angle se dekhun aur samajhun.

Main apne aapko hamesha badhi manti hoon, aur yakin hai ki Bhagwan ne mujhe kuch jyada quality di hai. Har kadam par, main apne aapko aur apne skills ko enhance karne mein lagataar vruddhi karti hoon.

Main yeh website apne volleyball journey, experiences, aur insights ko aapke saath share karne ke liye banaya hai. Aasha hai ki aap mere saath judkar, volleyball ke jadoo ko aur bhi gehraai se samajhenge aur enjoy karenge.

Dhanyavaad!

Vaishnavi
      </p>
    </section>
  );
};
export default AboutMe;
